import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    getTunnelState,
    selectTunnelState,
    selectTunnelStateLoading,
    selectTunnelStateFailed,
    selectRetryCount,
} from "./tunnelStateSlice";
import classes from './TunnelState.module.css';
import { isEmpty } from "../../util/utils";
import Spinner from "../ui/Spinner";

export const TunnelState = () => {
    const dispatch = useDispatch();
    const tunnelState = useSelector(selectTunnelState);
    const tunnelStateLoading = useSelector(selectTunnelStateLoading);
    const tunnelStateFailed = useSelector(selectTunnelStateFailed);
    const retryCount = useSelector(selectRetryCount);

    useEffect(() => {
        if (isEmpty(tunnelState) && !tunnelStateLoading && !tunnelStateFailed && retryCount === 0) {
            dispatch(getTunnelState());
        }
    }, [dispatch, tunnelState, tunnelStateLoading, tunnelStateFailed, retryCount]);

    if (isEmpty(tunnelState) && !tunnelStateFailed) {
        return (
            <div className={classes.TunnelStateContainer}>
                <Spinner />
            </div>
        );
    }

    return null;
};
